import React, { useState } from 'react';
import { CustomButton, CustomInput, CustomModal } from 'components';
import { InputType } from 'components/custom-input.tsx/CustomInput';
import { getAmountWithCurrency } from 'utils/amountUtils';
import { REGEX } from 'constants/common';
import { InvoiceByIdV2 } from '../invoices.model';
import { ButtonType } from 'components/custom-button/CustomButton';
import FormCloseReactIcon from 'assets/react-icons/FormCloseReactIcon';

interface RecordTipModalProps {
  isOpen: boolean;
  onClose: () => void;
  onTipRecorded: (tipAmount: number) => void;
  invoiceData: InvoiceByIdV2;
  selectedAmount: number;
  tipRecorded: number;
}

const RecordTipModal: React.FC<RecordTipModalProps> = ({
  isOpen,
  onClose,
  onTipRecorded,
  invoiceData,
  selectedAmount,
  tipRecorded
}) => {
  const [tipAmount, setTipAmount] = useState<string>(tipRecorded ? tipRecorded.toString() : '');

  const handleTipAmountChange = (value: string) => {
    if (value === '' || (REGEX.maximumTwoDecimals.test(value) && +value <= +currentPaymentAmount * 0.99)) {
      setTipAmount(value);
    }
  };

  const handleRecordTip = () => {
    const amount = tipAmount ? parseFloat(tipAmount) : 0;

    onTipRecorded(amount);
    setTipAmount('');
  };

  const handleCancel = () => {
    setTipAmount('');
    onClose();
  };
  const currentPaymentAmount = selectedAmount || invoiceData?.pendingAmount;
  const totalAmount = Number(currentPaymentAmount) + parseFloat(tipAmount);

  const tipAmountDisplay = `Total payment amount = ${getAmountWithCurrency(totalAmount)} (${getAmountWithCurrency(
    currentPaymentAmount
  )} + ${getAmountWithCurrency(parseFloat(tipAmount))} tip)`;

  const isValidAmount = +tipAmount <= +currentPaymentAmount * 0.99;

  return (
    <CustomModal open={isOpen} closeModal={handleCancel} className="md:w-[341px]">
      <div className="relative p-6">
        <div className="flex items-center justify-between pb-6">
          <div className="text-xl font-bold text-heading">Record tip</div>
          <FormCloseReactIcon
            id="record-tip-modal-close"
            height="24"
            width="24"
            className="absolute top-2 right-2 cursor-pointer"
            onClick={handleCancel}
          />
        </div>

        <div className="mb-6">
          <CustomInput
            id="tip-amount-input"
            type={InputType.TEXT}
            placeholder="0.00"
            value={tipAmount}
            onChange={handleTipAmountChange}
            className="h-[48px] w-full pl-7 !text-[#454545] outline-none"
            prefixWrapperStyle="left-3 !text-[#454545]"
            prefix="$"
          />
          {tipAmount && <div className="mt-2 text-sbase text-primaryText">{tipAmountDisplay}</div>}
        </div>

        <div className="flex gap-3">
          <CustomButton
            id="record-tip-cancel-btn"
            onClick={handleCancel}
            type={ButtonType.SECONDARY}
            className="flex-1 border border-primaryBtn bg-primaryBtnText text-primaryBtn">
            Cancel
          </CustomButton>
          <CustomButton
            id="record-tip-save-btn"
            onClick={handleRecordTip}
            disabled={!isValidAmount}
            className="flex-1 bg-primaryBtn text-primaryBtnText disabled:opacity-50">
            Done
          </CustomButton>
        </div>
      </div>
    </CustomModal>
  );
};

export default RecordTipModal;
